import { useEffect } from 'react';
import { DATADOG_CUSTOM_ACTIONS } from 'src/_shared/datadog/DatadogCustomActions';
import Datadog from 'src/_shared/datadog/index.web';
import { BOOTSTRAP_CONTEXT, captureConnectionContext } from 'src/_shared/datadog/bootstrapContext';

export const useAfterAppLoaded = () => {
  useEffect(() => {
    Datadog.endMeasure(DATADOG_CUSTOM_ACTIONS.editor_ready_time, { ...BOOTSTRAP_CONTEXT, ...captureConnectionContext() });
  }, []);
};
